<template>
	<v-container class="mt-12 pt-8" style="background:#efefef;">
		<v-row style="background:#efefef;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12">
						<v-card :loading="loading">
							<v-card-text>
								<v-row>
									<v-col cols="12">
										<v-row class="align-center">
											<v-col cols="2" class="text-center" TITLE>
												<v-icon size="40" color="secondary">person</v-icon>
											</v-col>
											<v-col cols="10" TITLE>
												<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">GAMA Leads</div>
											</v-col>
										</v-row>
									</v-col>


									<v-col cols="12" class="py-1">
										<v-text-field prepend-inner-icon="search" type="text" outlined label="Search" compact="comfort"
											clearable hide-details dense v-model="search"
											@click:clear="() => { search = null; pageByNumber(page) }" />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.search_columns" label="Search fields"
											:items="available_columns" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'search_columns')">
													{{ data.item.text }}
												</v-chip>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.exclude_columns" label="Exclude fields"
											:items="available_columns" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'exclude_columns')">
													{{ data.item.text }}
												</v-chip>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.cities" :label="i18n.city" :items="cities"
											item-text="name" item-value="id" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'cities')">
													{{ data.item.name }}
												</v-chip>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.categories" :label="'Category'" :items="categories"
											item-text="name" item-value="id" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'categories')">
													{{ data.item.name }}
												</v-chip>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.accounts" :label="'Accounts'" :items="accounts"
											item-text="name" item-value="id" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'accounts')">
													{{ data.item.name }}
												</v-chip>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<DatePicker label="Expiry date" hide-details :value.sync="filters.expiry_date" range />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.expiry_year" :label="'Expiry year'"
											:items="expiry_years" item-text="name" clearable item-value="id" outlined dense />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.expired" label="Is expired" clearable
											:items="expired_items" outlined dense />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<DatePicker label="Established date" hide-details :value.sync="filters.est_date" range />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details v-model="filters.est_year" :label="'Esablished year'" :items="est_years"
											item-text="name" clearable item-value="id" outlined dense />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details :search-input.sync="exclude_word" v-model="filters.exclude_words"
											label="Exclude words" :items="excluded_words" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'exclude_words')">
													{{ data.item.text }}
												</v-chip>
											</template>

											<template v-slot:no-data>
												<v-btn @click.prevent="addNewExcludedWord()" text plain block>Click to add the word</v-btn>
											</template>
											
											<template v-slot:append>
												<v-btn @click.stop="toggleImportDialog('exclude')" color="primary" small text>Import</v-btn>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-autocomplete hide-details :search-input.sync="include_word" v-model="filters.include_words"
											label="Include words" :items="included_words" multiple chips deletable-chips outlined dense>
											<template v-slot:selection="data">
												<v-chip small v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
													@click:close="remove(data.item, 'include_words')">
													{{ data.item.text }}
												</v-chip>
											</template>

											<template v-slot:no-data>
												<v-btn @click.stop="addNewIncludedWord()" text plain block>Click to add the word</v-btn>
											</template>
											
											<template v-slot:append>
												<v-btn @click.stop="toggleImportDialog('include')" color="primary" small text>Import</v-btn>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="py-1">
										<v-text-field
											label="Export limit"
											type="number"
											outlined 
											hide-details
											dense
											v-model="export_limit"
										/>
									</v-col>

									<v-col md="4" sm="6" cols="12" class="d-flex align-items-center py-1">
										<v-switch hide-details class="mt-0" label="Not a branch" v-model="filters.not_branch" />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="d-flex align-items-center py-1">
										<v-switch hide-details class="mt-0" label="Is branch" v-model="filters.is_branch" />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="d-flex align-items-center py-1">
										<v-switch hide-details class="mt-0" label="Has email" v-model="filters.has_email" />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="d-flex align-items-center py-1">
										<v-switch hide-details class="mt-0" label="Has phone" v-model="filters.has_phone" />
									</v-col>

									<v-col md="4" sm="6" cols="12" class="d-flex align-items-center py-1">
										<v-switch hide-details class="mt-0" label="Has mobile" v-model="filters.has_mobile" />
									</v-col>

									<v-col cols="12" class="py-1">
										<v-row>
											<v-col cols="auto" class="mx-auto">

												<v-btn color="primary" @click.prevent="callFilter(page)">
													<v-icon small>filter_list</v-icon>
													<span>Filter</span>
												</v-btn>
												<v-btn color="primary" class="ml-2" @click.prevent="exportData">
													<v-icon small>download</v-icon>
													<span>Export</span>
												</v-btn>
												<a href="" style="display: none;" ref="dowlink"></a>
												<v-btn class="ml-4" color="deep-orange" dark @click.prevent="reset()">
													<v-icon small>restart_alt</v-icon>
													<span>Reset</span>
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
									<v-col cols="12">
										<v-row>
											<v-col cols="auto" class="mx-auto">
												<v-chip label dark color="primary" small>{{ resource.total }}</v-chip> Leads
											</v-col>
										</v-row>
									</v-col>


									<v-col cols="12">
										<v-divider></v-divider>
									</v-col>

									<v-col cols="12">
										<Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
											@pageByNumber="pageByNumber" />
									</v-col>

									<v-col cols="12">
										<ListLeads :leads="resource.data" />
									</v-col>

								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<v-dialog
      v-model="importDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
					Import words to {{ wordTarget }} words filter
        </v-card-title>
        <v-card-text>
					<v-textarea label="Put your words to import here" dense hide-details v-model="words" outlined />
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="importDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="importWords"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</v-container>
</template>

<script>
import Paging from '@/components/Paging.vue'
import ListLeads from '@/components/ListLeads.vue'
import DatePicker from '@/components/DatePicker.vue'
import _ from 'lodash'

export default {
	components: {
		Paging,
		ListLeads,
		DatePicker,
	},
	data() {
		return {
			importDialog: false,
			wordTarget: null,
			words: null,
			export_limit: null,
			loading: false,
			exclude_word: '',
			include_word: '',
			page: 1,
			search: null,
			resourceSettings: {
				pagination: true
			},
			excluded_words: [],
			included_words: [],
			resource: {},
			cities: [],
			categories: [],
			accounts: [],
			est_years: [],
			expiry_years: [],
			expired_items: [
				{ text: 'Yes', value: true },
				{ text: 'No', value: false },
			],
			filters: {
				cities: [],
				categories: [],
				accounts: [],
				expiry_date: [],
				expired: null,
				est_date: [],
				search_columns: [],
				exclude_columns: [],
				exclude_words: [],
				include_words: [],
				est_year: null,
				expiry_year: null,
				not_branch: false,
				is_branch: false,
				has_email: false,
				has_phone: false,
				has_mobile: false,
			},
			available_columns: [
				{ text: 'business_name_arabic', value: 'business_name_arabic' },
				{ text: 'category', value: 'category' },
				{ text: 'business_name_english', value: 'business_name_english' },
				{ text: 'full_address', value: 'full_address' },
				{ text: 'economic_department', value: 'economic_department' },
				{ text: 'registration_ed_branch', value: 'registration_ed_branch' },
				{ text: 'email', value: 'email' },
				{ text: 'web_site_url', value: 'web_site_url' },
			],
		}
	},
	methods: {
		async callFilter(page) {
			this.loading = true

			this.resource = await this.$store.dispatch('postResource', { resource: `/gama-leads/filter?page=` + page, value: this.filtersAsObject });
			this.resource
			this.resource = { ...this.resource.leads }

			this.loading = false
		},
		toggleImportDialog(target) {
			this.wordTarget = target
			this.importDialog = true
		},
		importWords() {
			if (this.wordTarget == 'exclude') {
				this.excluded_words = this.words.split("\n").filter(item => item != "").map(function (item) {
					return {
						text: item,
						value: item,
					}
				})
				this.filters.exclude_words = this.excluded_words.map(function (item) {
					return item.value
				}) 
			}
			else {
				this.included_words = this.words.split("\n").filter(item => item != "").map(function (item) {
					return {
						text: item,
						value: item,
					}
				})
				this.filters.include_words = this.included_words.map(function (item) {
					return item.value
				}) 
			}

			this.importDialog = false
			this.words = null
			this.wordTarget = null
		},
		async exportData() {
			this.loading = true
			let _link = null
			if (this.export_limit) {
				_link = await this.$store.dispatch('postResource', { resource: `/gama-leads/export?limit=${this.export_limit}`, value: this.filtersAsObject });
			}
			else {
				_link = await this.$store.dispatch('postResource', { resource: `/gama-leads/export?page=1`, value: this.filtersAsObject });
			}
			this.$refs.dowlink.href = _link
			this.$refs.dowlink.click()
			this.loading = false
		},
		addNewIncludedWord() {
			if (this.include_word) {
				this.included_words.push({
					text: this.include_word, value: this.include_word
				})

				this.filters.include_words.push(this.include_word)
				this.include_word = null
			}
		},
		addNewExcludedWord() {
			if (this.exclude_word) {
				this.excluded_words.push({
					text: this.exclude_word, value: this.exclude_word
				})

				this.filters.exclude_words.push(this.exclude_word)
				this.exclude_word = null
			}
		},
		remove(item, field) {
			let index = this.filters[field].indexOf(item.value)
			if (item.id) {
				index = this.filters[field].indexOf(item.id)
			}
			if (index >= 0) this.filters[field].splice(index, 1)
		},
		setResourceName() {
			this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
		},
		async loadResource() {
			this.loading = true
			const {
				cities,
				categories,
				accounts,
				est_years,
				expiry_years
			} = await this.$store.dispatch('getResource', { resource: '/gama-leads/resources/get' })
			this.cities = cities
			this.categories = categories
			this.accounts = accounts
			this.est_years = est_years
			this.expiry_years = expiry_years

			const data = await this.$store.dispatch('getResource', { resource: '/gama-leads' })
			this.resource = { ...data.leads }

			this.filters.cities = []
			this.search = ''
			this.loading = false
		},
		async reset() {
			this.filters = {
				cities: [],
				categories: [],
				accounts: [],
				expiry_date: [],
				expired: null,
				est_date: [],
				search_columns: [],
				exclude_columns: [],
				exclude_words: [],
				include_words: [],
				est_year: null,
				expiry_year: null,
				not_branch: false,
				is_branch: false,
			};

			this.search = null

			this.pageByNumber(this.page)
		},
		async pageByNumber(page) {
			this.page = page
			this.loading = true
			if (this.search) {
				this.resource = await this.$store.dispatch('getResource', { resource: `/gama-leads?page=${page}` + this._filters + `&search=${this.search}` })
			}
			else {
				this.resource = await this.$store.dispatch('getResource', { resource: `/gama-leads?page=${page}` + this._filters })
			}
			this.resource = { ...this.resource.leads }
			this.loading = false
		}
	},
	computed: {
		filtersAsObject() {
			return this._filters.split('&').filter(item => item != '').reduce((acc, curr) => {
				const [key, value] = curr.split('=')
				acc[key] = value
				return acc
			}, {})
		},
		_filters() {
			let filter = '';

			if (this.filters.cities.length > 0) {
				filter += `&cities=${this.filters.cities.join(",")}`
			}

			if (this.filters.expiry_year) {
				filter += `&expiry_year=${this.filters.expiry_year}`
			}

			if (this.filters.categories.length > 0) {
				filter += `&categories=${this.filters.categories.join(",")}`
			}

			if (this.filters.accounts.length > 0) {
				filter += `&accounts=${this.filters.accounts.join(",")}`
			}

			if (this.filters.expiry_date.length > 1) {
				filter += `&expiry_date=${this.filters.expiry_date}`
			}

			if (this.filters.expired !== undefined && this.filters.expired !== null) {
				filter += `&expired=${this.filters.expired}`
			}

			if (this.filters.est_date.length > 1) {
				filter += `&est_date=${this.filters.est_date}`
			}

			if (this.filters.search_columns.length > 0) {
				filter += `&search_columns=${this.filters.search_columns.join(',')}`
			}

			if (this.filters.exclude_columns.length > 0) {
				filter += `&exclude_columns=${this.filters.exclude_columns.join(',')}`
			}

			if (this.filters.exclude_words.length > 0) {
				filter += `&exclude_words=${this.filters.exclude_words.join(',')}`
			}

			if (this.filters.include_words.length > 0) {
				filter += `&include_words=${this.filters.include_words.join(',')}`
			}

			if (this.filters.est_year) {
				filter += `&est_year=${this.filters.est_year}`
			}

			if (this.filters.not_branch) {
				filter += `&not_branch=${this.filters.not_branch}`
			}

			if (this.filters.is_branch) {
				filter += `&is_branch=${this.filters.is_branch}`
			}

			if (this.filters.has_email) {
				filter += `&has_email=${this.filters.has_email}`
			}

			if (this.filters.has_phone) {
				filter += `&has_phone=${this.filters.has_phone}`
			}

			if (this.filters.has_mobile) {
				filter += `&has_mobile=${this.filters.has_mobile}`
			}

			return filter
		},
		api() {
			return this.$store.state.settings.apiBase
		},
		users() {
			let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
			return this.$store.state.users.filter(x => {
				if (!sa) {
					return x.superior == this.$store.state.user.level
				} else return x
			})
		},
		site() {
			return this.$store.state.site
		},
		items() {
			return this.$store.state.menu
		},
		superAdmin() {
			return this.$store.state.superAdmin
		},
		isLogin() {
			return this.$store.state.centralLogin
		},
		language() {
			return this.$store.state.language
		},
		globalLoading() {
			return this.$store.state.globalLoading
		},
		user() {
			return this.$store.state.user
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
		routeTitle() {
			let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
			let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route.path)
			if (main.length) {
				return this.$store.state.i18n[this.$store.state.language][main[0].text]
			} else if (sub.length) {
				return this.$store.state.i18n[this.$store.state.language][sub[0].text]
			} else {
				return ''
			}
		},
		roles() {
			return this.$store.state.userRoles
		},
		notifications() {
			return this.$store.state.notifications
		},
	},
	async created() {
		this.setResourceName()
		await this.loadResource()
	},
}
</script>
<style scoped>
*:not(i) {
	font-family: 'Poppins', sans-serif;
}
</style>